import React from 'react'
import debounce from 'lodash/debounce'
import Icon from '../misc/Icons'


const SET_TITLE_MAX_CHARACTER_LENGTH=60
const DEBOUNCE_TIME=300
const SET_TITLE_PLACEHOLDER='Untitled Set'
 
class SetTitleInputField extends React.Component{

	constructor(props){
		super(props)
		this.onChange=this.onChange.bind(this)		
		this.saveChanges=this.saveChanges.bind(this)	
		this.saveChanges = debounce(this.saveChanges,DEBOUNCE_TIME,{'leading': false })
		
		var setTitle=props.title
		if(props.title===SET_TITLE_PLACEHOLDER){
			setTitle=''
		}

		this.state={
			value:setTitle
		}
	}


	UNSAFE_componentWillReceiveProps(nextProps) {
		if(this.props.title !== nextProps.title){	
			this.setState({
				value:nextProps.title,
			})
		}
	}




	onKeyDown(e){
		if(e.which === 13) {
			//blur input when press enter
			document.getElementById('updateSetTitleField').blur()
		}
	}

	onChange(e){
		this.setState({value:e.target.value})
		this.saveChanges()
	}

	saveChanges(){
		let setTitle=this.state.value
		if(setTitle===''){
			setTitle=SET_TITLE_PLACEHOLDER
		}
		this.props.updateSetTitle(setTitle)
	}


	render(){
		
		const {inSharedRepo, isViewOnly, isPublicConsumer, isPublicAuthor} = this.props 

		return(
			<div className={'itemEditor-topBar-titleForm ' + ((this.props.isViewOnly || this.props.lockedByAnotherUser) ? 'itemEditor-topBar-titleForm--disabled' : '')}>				
				<div className={'itemEditor-topBar-titleForm-field ' + (this.state.value === '' ? 'itemEditor-topBar-titleForm-field--empty' : ' ')} > 
					<input						
						value={this.state.value}
						tabIndex='-1' 
						type={'textarea'}		
						onKeyDown={this.onKeyDown}		
						onChange={this.onChange}
						id='updateSetTitleField'
						maxLength={SET_TITLE_MAX_CHARACTER_LENGTH}
						placeholder={SET_TITLE_PLACEHOLDER}
						autoComplete="off"
						autoCorrect="off"
						autoCapitalize="off"
						spellCheck="false"
						disabled={this.props.isViewOnly || this.props.lockedByAnotherUser}
					/>
					<div className='itemEditor-topBar-titleForm-field-spacer'>						
						{this.state.value}						
					</div>
				</div>
				{(inSharedRepo || isViewOnly || isPublicAuthor || isPublicConsumer) && 
					<div className='itemEditor-topBar-titleForm-sharedIcon'>
						{this.state.value || SET_TITLE_PLACEHOLDER}												
						<div className='itemEditor-topBar-titleForm-sharedIconContainer'>
							{inSharedRepo &&
								<Icon name='shared' />
							}
							{!inSharedRepo && isViewOnly && !isPublicConsumer &&
								<Icon name='lock' />
							}
							{isPublicConsumer &&
								<Icon name='globe-shared' />
							}
							{isPublicAuthor &&
								<Icon name='globe-shared-author' />
							}

						</div>
					</div>
				}
     	</div>
		)
	}
}


export default SetTitleInputField
